import { AxiosRequestConfig } from 'axios';

// import { msalInstance } from "../../pages/AuthCallBack/AuthCallback";
import { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from "./authConfig";
import { msalInstance }  from './appAD';

// async function tokenInterceptor(config: AxiosRequestConfig) {
//   // const token = localStorage.getItem('token');

//   const newConfig = { ...config, headers: config.headers || {} };
//   if (token) {
//     newConfig.headers.Authorization = `Bearer ${token}`;
//   }
//   if (!token) {
//   console.warn("No token found");
// }

//   return newConfig;
// }

export async function tokenInterceptor( config: AxiosRequestConfig) {

  console.log("Interceptor running");
  const account = msalInstance.getActiveAccount();

  if (!account) return config;

  const token = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account
  });

  localStorage.setItem('token', token.accessToken);
  
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      Authorization: `Bearer ${token.accessToken}`
    }
  };
}
